import { CHARACTERS, type CharacterId } from '../content/characters';
import { EVOLUTION_ASSETS } from '../../audio/evolutionCues';
import { PHASE_TRANSITION_ASSETS } from '../../audio/phaseCues';

const CHARACTER_ART_VERSION = '20260911';
const EVOLUTION_AUDIO_VERSION = '20260913-selected5';

export function characterAssetPath(id: CharacterId): string {
  const version = id === 'revival-stone' ? '20260922-white-interior' : CHARACTER_ART_VERSION;
  return `assets/characters/${id}.webp?v=${version}`;
}

export const CHARACTER_ASSETS = CHARACTERS.map((character) => ({
  key: character.textureKey,
  path: characterAssetPath(character.id),
}));

export const FONT_ASSETS = {
  heading: 'assets/fonts/KaiseiTokumin-Bold.woff2',
  body: 'assets/fonts/KaiseiTokumin-Regular.woff2',
  numerals: 'assets/fonts/Cinzel-Bold.woff2',
} as const;

export const AUDIO_ASSETS = [
  ...EVOLUTION_ASSETS,
  ...PHASE_TRANSITION_ASSETS,
  'drop-confirm',
  'contact-light',
  'contact-heavy',
  'merge-normal',
  'merge-high',
  'chain-rise',
  'danger-warning',
  'resonance-ascension',
  'card-ui',
  'shinra-generation',
  'observer-jingle',
  'game-over',
  'button',
] as const;

export type AudioAssetKey = (typeof AUDIO_ASSETS)[number];

export function audioSources(key: AudioAssetKey): readonly string[] {
  if (key.startsWith('phase-transition-')) {
    const phase = key.slice('phase-transition-'.length);
    return [`assets/audio/resonance/phase-${phase}.ogg`, `assets/audio/resonance/phase-${phase}.mp3`];
  }
  if (key.startsWith('evolution-')) {
    const name = key.slice('evolution-'.length);
    return [`assets/audio/evolution/${name}.ogg?v=${EVOLUTION_AUDIO_VERSION}`, `assets/audio/evolution/${name}.mp3?v=${EVOLUTION_AUDIO_VERSION}`];
  }
  return [`assets/audio/${key}.ogg`, `assets/audio/${key}.mp3`];
}
